export const METRICS_PAGE_ID = 'board-settings-apps.timeline-page';

export const BOARD_SETTINGS_ARTICLE_ID_TIMELINE = '7cZNhzcOibrnSHjHkaI0XY';
export const BOARD_SETTINGS_ARTICLE_ID_TIMELINE_ANALYTICS_ID = `${METRICS_PAGE_ID}.cmp.article.analytics`;

export const START_AND_DUE_DATE_SCHEDULING = 'start-and-due-date-scheduling';
export const SPRINT_DATES_SCHEDULING = 'sprint-dates-scheduling';
